import { cn } from '../../utils/cn';

// PageHeader — standard page header used by settings, CRUD and dashboard views.
//
// Layout:
//   <h1> [icon] {title} </h1>      [actions slot - right]
//   <p class="text-sm muted">{subtitle}</p>
//
// Props:
//   - icon?: ReactNode (e.g. <UserIcon className="w-6 h-6 text-fg-muted" />)
//   - title: ReactNode
//   - subtitle?: ReactNode
//   - actions?: ReactNode (right-aligned cluster — buttons, links, filters)
//   - className?: string

export function PageHeader({ icon, title, subtitle, actions, className }) {
  return (
    <header
      className={cn(
        // Hook semántico para la capa global de densidad compacta
        // (_density-compact.scss, activa con viewport bajo + puntero fino).
        'ui-page-header',
        'flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3',
        className,
      )}
    >
      <div className="space-y-1 min-w-0">
        <h1 className="text-2xl font-semibold text-fg flex items-center gap-2">
          {icon}
          <span className="line-clamp-2 sm:truncate">{title}</span>
        </h1>
        {subtitle && (
          <p className="text-sm text-fg-muted">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>
      )}
    </header>
  );
}

PageHeader.displayName = 'PageHeader';

export default PageHeader;
